import store from "@/store";

export const ListParties = {
  methods: {
    getListPartyCount(candidateIds) {
      const partyIds = candidateIds.map(candidateId => {
        let candidate = store.getters["candidate/candidate"](candidateId);
        return candidate.partyId;
      });
      function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      }

      return partyIds.filter(onlyUnique).length;
    },
    getListParties(candidates) {
      const getParty = store.getters["party/party"];
      const entries = candidates.reduce((acc, val) => {
        let candidate = store.getters["candidate/candidate"](val);
        if (acc[candidate.partyId] === undefined) {
          acc[candidate.partyId] = 1;
        } else {
          acc[candidate.partyId] += 1;
        }

        return acc;
      }, {});

      return Object.entries(entries)
        .sort(([, a], [, b]) => b - a)
        .map(([partyId, count]) => [
          getParty(partyId),
          count / candidates.length
        ]);
    }
  }
};
